import { Localizable } from '@components/localizable/Localizable'
import { NotificationContentKey } from '@models/NotificationContent'
import { useAppSelector } from '@store/hooks'
import { selectNotificationContentByKey } from '@store/NotificationContentReducer'
import { SBRMFormAction, useSBRMForm } from '@supplement-bacon/sbrm-react'
import MetadataKey from '@utils/MetadataKey'
import { requiredRule } from '@utils/rules'
import { Flex, Form, Input } from 'antd'
import { useEffect, useMemo } from 'react'

const Update: SBRMFormAction = ({ form, formProps }) => {
  const { metadata, getMetadata } = useSBRMForm()

  const notificationContentKey = useMemo(
    () => getMetadata(MetadataKey.NotificationContent),
    [getMetadata, metadata]
  )
  const maxTitleLenghtKey = useMemo(
    () => getMetadata(MetadataKey.maxTitle),
    [metadata]
  )
  const maxContentLenghtKey = useMemo(
    () => getMetadata(MetadataKey.maxContent),
    [metadata]
  )

  const textEditorVariables = useMemo(
    () => getMetadata(MetadataKey.textEditorVariables),
    [metadata]
  )

  const item = useAppSelector(
    selectNotificationContentByKey(notificationContentKey)
  )

  const isTextEditorKey = useMemo(
    () =>
      notificationContentKey &&
      [
        NotificationContentKey.RESERVATION_PLACED,
        NotificationContentKey.RESERVATION_UPDATED,
        NotificationContentKey.RESERVATION_CANCELLED,
        NotificationContentKey.BUSINESS_COMPANY_CONTACT_ADDED,
        NotificationContentKey.BUSINESS_COMPANY_CONTACT_CONFIRMATION_ADD,
        NotificationContentKey.BUSINESS_PROFILE_LINKING_CODE,
        NotificationContentKey.REGISTER_REQUIRED_OPT_IN_DATA,
        NotificationContentKey.REGISTER_OPTIONAL_OPT_IN_MARKETING,
        NotificationContentKey.REGISTER_EXTRA_TEXT,
        NotificationContentKey.GDPR_ACCOUNT_RETENTION_WARNING,
      ].includes(notificationContentKey),
    [notificationContentKey]
  )

  const displayButtonLabel = useMemo(
    () =>
      notificationContentKey &&
      [NotificationContentKey.MEMBERSHIP_BIRTHDAY_MODAL].includes(
        notificationContentKey
      ),
    [notificationContentKey]
  )

  const displayTitle = useMemo(
    () =>
      notificationContentKey &&
      ![
        NotificationContentKey.REGISTER_REQUIRED_OPT_IN_DATA,
        NotificationContentKey.REGISTER_OPTIONAL_OPT_IN_MARKETING,
        NotificationContentKey.REGISTER_EXTRA_TEXT,
        NotificationContentKey.RESERVATION_PAYLINK_NOTE_TO_GUEST,
      ].includes(notificationContentKey),
    [notificationContentKey]
  )

  useEffect(() => {
    form.setFieldsValue({
      id: item?.id,
      key: notificationContentKey,
      ...item,
    })
  }, [item])

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden noStyle>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="key" hidden noStyle>
        <Input type="hidden" />
      </Form.Item>
      {displayTitle && (
        <Localizable.Input
          max={maxTitleLenghtKey}
          name="title"
          rules={[requiredRule()]}
          label={'Title'}
        />
      )}
      {!displayTitle && (
        <Flex style={{ display: 'none' }}>
          <Localizable.Input
            name="title"
            rules={[requiredRule()]}
            initialValue={'title'}
          />
        </Flex>
      )}
      {!isTextEditorKey && (
        <Localizable.TextArea
          max={maxContentLenghtKey}
          name="content"
          rules={[requiredRule()]}
          label={'Content'}
        />
      )}
      {isTextEditorKey && (
        <Localizable.TextEditor
          name="content"
          rules={[requiredRule()]}
          label={'Content'}
          variables={textEditorVariables}
        />
      )}
      {displayButtonLabel && (
        <Localizable.Input
          name="buttonLabel"
          rules={[requiredRule()]}
          label={'Button label'}
        />
      )}
    </Form>
  )
}

export default Update
